import { createContext, useContext } from 'react';

/**
 * True while a component renders on the editor canvas. Set by
 * `createPuckConfig` for components that change interaction while authors
 * edit them; published renderers never provide it.
 */
export const CatalogEditingContext = createContext(false);

export const useCatalogEditing = (): boolean =>
  useContext(CatalogEditingContext);
